import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Capacitor } from '@capacitor/core';

// Prefer loopback that works inside native webview
const defaultApiBase = process.env.REACT_APP_API_URL || 'http://localhost:4000';
const nativeApiBase = Capacitor.isNativePlatform()
  ? 'http://127.0.0.1:4000'
  : defaultApiBase;

export const API_URL = nativeApiBase;
console.log('API_URL:', API_URL);

// Global error handlers to prevent app crashes
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  // Prevent the default browser behavior (logging to console)
  event.preventDefault();

  // You could show a toast notification here instead of console.error
  // For now, we'll just prevent the app from crashing
});

window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
  // Prevent the default browser behavior
  event.preventDefault();
});

export { default as Landing } from "./components/Landing/Landing";
export { default as Home } from "./components/Home/Home";
export { default as Launch } from "./components/Launch/Launch";
export { default as StartTrip } from "./components/StartTrip/StartTrip";
export { default as FindTripAsRider } from "./components/FindTripAsRider/FindTripAsRider";
export { default as ViewResultAsRider } from "./components/ViewResultAsRider/ViewResultAsRider";
export { default as PastTrips } from "./components/PastTrips/PastTrips";
export { default as UpcomingTrips } from "./components/UpcomingTrips/UpcomingTrips";
export { default as PendingTrips } from "./components/PendingTrips/PendingTrips";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
